<template>
    <span>
        <span class="debug" v-if="debug">
            Allocations {{ allocations_by_key }}
            <br />
            {{ selected_row }}, {{ selected_col }}

            <br /><br />

            {{ resource_headers[resource_headers.length] }}
        </span>
        <table>
            <tr class="header_row" v-for="(row, row_no) in resource_headers">
                <td class="header_cell">
                    {{ resource_config[row_no].title }}
                </td>
                <td
                    :class="{
                        header_cell: true,
                        active_col: is_col_active(cell),
                    }"
                    :colspan="cell.span"
                    v-for="cell in row"
                >
                    <div><slot :item="cell" name="resource-header"></slot></div>
                </td>
            </tr>

            <tr
                :class="{ active_row: is_row_active(task) }"
                :key="task[task_key]"
                v-for="task in tasks"
            >
                <td
                    :class="{
                        header_cell: true,
                        active_row: is_row_active(task),
                    }"
                    @mouseover="hover(task, null)"
                >
                    <slot :item="task" name="task-row"></slot>
                </td>
                <td
                    :class="{
                        allocation_cell: true,
                        active_row: is_row_active(task),
                        active_col: is_col_active(resource),
                    }"
                    :key="create_key(task[task_key], resource.id)"
                    @mouseover="hover(task, resource)"
                    v-for="resource in last_header_row"
                >
                    <div
                        @click="allocate(task, resource)"
                        class="cell"
                        v-bind:class="_calc_cell_class(task, resource)"
                    >
                        <slot
                            :item="getAllocation(task, resource)"
                            :resource="resource"
                            :task="task"
                            name="allocation-cell"
                        ></slot>

                        <span class="debug" v-if="debug"
                            >{{ task[task_key] }} : {{ resource.id }}</span
                        >
                    </div>
                </td>
            </tr>
        </table>
    </span>
</template>

<script>
import _ from "lodash";

/* This screen allocates "allocations" for each Task (Left Hand Side) and Resource (Top Header)

        Resources can be nested.. ie Driver, Run etc..

        NOTE: this has not been used in a project - it was written but NOT used.
     */

export default {
    name: "OResourceAllocation",
    data() {
        return {
            selected_row: null,
            selected_col: null,
        };
    },
    props: {
        tasks: {
            type: Array,
            default: () => [],
        } /* List of Tasks on Left Hand Side*/,
        task_key: {
            type: String,
            default: "id",
        } /* Fieldname for id in the Tasks */,

        resources: { type: Array, default: () => [] } /* List if Resources */,
        /* Config how to read resources,
                key=Field name for unique id of the allocation ie the ID of the model,
                children_key= Field name for children list for next level,
                title= Title to show for the Level
                allocation_key: The field to set on the allocation for this level
             */
        resource_config: {
            type: Array,
            default: () => [
                {
                    key: "id",
                    children_key: "children",
                    title: "Resource 1",
                    allocation_key: "res_id",
                },
            ],
        },

        allocations: {
            type: Array,
            default: () => [],
        } /* The Allocation data */,
        allocation_key: {
            type: String,
            default: "id",
        } /* The fieldname that is a unique id of the allocation */,
        allocation_task_key: {
            type: String,
            default: "task_id",
        } /* The field to set in the allocation for the task */,

        cell_class: { type: Function, default: null },

        debug: { type: Boolean, default: false },
    },
    methods: {
        create_key(task_id, resource_ids) {
            /*
                    Create a KEY for the allocation
                */
            return (task_id || "") + ":" + (resource_ids || [""]).join(",");
        },
        getAllocation(task, resource) {
            /* Find an allocation for the Task and Resource
                return Null/Undefined if not found
                */
            var key = this.create_key(task[this.task_key], resource.id);

            var result = this.allocations_by_key[key];

            return result;
        },
        allocate(task, resource) {
            /* Allocate a Task + Resource
                    If an allocation exists then remove it.
                */
            var existing = this.getAllocation(task, resource);

            // Only add if not there already
            if (existing) {
                // remove it!
                var index = this.allocations.indexOf(existing);

                if (index > -1) {
                    this.$delete(this.allocations, index);

                    this.$emit("remove", existing);
                }
            } else {
                var newAllocation = {};

                newAllocation[this.allocation_task_key] = task[this.task_key];
                _.each(this.resource_config, function (res_config, index) {
                    newAllocation[res_config.allocation_key] =
                        resource.id[index];
                });

                this.allocations.push(newAllocation);

                this.$emit("add", newAllocation);
            }
        },

        hover(task, resource) {
            this.selected_row = task[this.task_key];
            if (resource) {
                this.selected_col = resource.id;
            }
        },

        is_row_active(task) {
            return this.selected_row === task[this.task_key];
        },
        is_col_active(resource) {
            if (resource && this.selected_col) {
                var match = true;

                for (var i = 0; i < resource.id.length; i++) {
                    match = match && this.selected_col[i] == resource.id[i];
                }

                return match;
            }

            return false;
        },
        _calc_cell_class(task, resource) {
            var item = this.getAllocation(task, resource);

            var result = {};

            if (this.cell_class != null && _.isFunction(this.cell_class)) {
                result = this.cell_class(item, task, resource);
            }

            result.active = item != null;
            return result;
        },
    },
    computed: {
        allocations_by_key() {
            /* Take the allocations and convert them to a dict so we can find them quickly
             */
            var vm = this;

            // Get the id's for each Resource Level from the allocation
            var result = _.mapKeys(this.allocations, function (allocation) {
                var resource_keys = _.map(
                    vm.resource_config,
                    function (res_config) {
                        return allocation[res_config.allocation_key];
                    }
                );

                return vm.create_key(
                    allocation[vm.allocation_task_key],
                    resource_keys
                );
            });

            return result;
        },
        last_header_row() {
            /* Get the LAST header row this is the one with all the ID's we need
             */
            if (this.resource_headers) {
                var last_row = this.resource_headers[
                    this.resource_headers.length - 1
                ];

                return last_row;
            } else {
                return [];
            }
        },
        resource_headers() {
            /*
             * Convert the Resources into a table structure that makes creating the TR/TD's easier..
             * */
            var rows = [];
            var vm = this;

            /*
                 |             LEVEL 0            |
                 |   0-0          | 0-1           |
                 | 0-0-0 | 0-0-1  | 0-1-0 | 0-1-1 |
                 */
            function collect_row(items, ids, level) {
                var cells = [];

                if (rows.length - 1 < level) {
                    rows.push([]); // add new row
                }

                _.each(items, function (item) {
                    var span = 1; // default to 1 for End of the line

                    var new_ids = ids.concat([item.id]); // Add ours to the list

                    // DO the children first
                    var children_key = vm.resource_config[level].children_key;
                    if (children_key) {
                        if (children_key in item) {
                            var child_row = collect_row(
                                item[children_key],
                                new_ids,
                                level + 1
                            );

                            span = _.sumBy(child_row, "span") || 1;
                        }
                    }

                    cells.push({
                        id: new_ids,
                        data: item,
                        title: item.title,
                        span: span,
                    });
                });

                rows[level] = rows[level].concat(cells);

                return cells;
            }

            _.each(this.resources, function (resource) {
                collect_row([resource], [], 0);
            });

            return rows;
        },
    },
};
</script>

<style scoped>
table {
    border-collapse: collapse;
    width: 100%;
}

table,
td,
th {
    border: 1px solid #a8a8a8;
}

.cell {
    border-left: 1px solid #f5f5f5;
    border-top: 1px solid #f5f5f5;
    border-right: 1px solid #bdbdbd;
    border-bottom: 1px solid #bdbdbd;
    border-radius: 5px;
    /*background: #ececec;*/
    width: 26px;
    height: 26px;
    display: inline-block;
    cursor: pointer;
}

.active {
    border-left: 2px solid #ceff8c;
    border-top: 2px solid #ceff8c;
    border-right: 2px solid #86ff70;
    border-bottom: 2px solid #86ff70;
    border-radius: 5px;
    /*background: #54fd6159;*/
    width: 26px;
    height: 26px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
}

cell:hover {
    background-color: #0d47a1;
    border: 1px solid blue;
    color: white;
}

.debug {
    font-size: 6pt;
}

tr.header_row {
}

td.header_cell {
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}

td.allocation_cell {
    background-color: white;
}

td.active_row {
    background: #008fd740;
}

td.active_col {
    background: #008fd740;
}
</style>
